import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SurveyService } from '../../../services/surveys.service';

const CENTER = 160;
const HALF = 110;

@Component({
  selector: 'app-paraconsistent-map',
  templateUrl: './paraconsistent-map.component.html',
  standalone: false,
})
export class ParaconsistentMapComponent {
  @Input() certainty: number | null = null;
  @Input() contradiction: number | null = null;
  @Input() status: string | null = null;
  @Input() tone = '#6b7280';

  readonly center = CENTER;
  readonly half = HALF;
  readonly top = CENTER - HALF;
  readonly bottom = CENTER + HALF;
  readonly left = CENTER - HALF;
  readonly right = CENTER + HALF;
  readonly diamond = `${CENTER},${CENTER - HALF} ${CENTER + HALF},${CENTER} ${CENTER},${CENTER + HALF} ${CENTER - HALF},${CENTER}`;

  constructor(
    private surveyService: SurveyService,
    private translateService: TranslateService,
  ) {}

  get hasPoint(): boolean {
    return typeof this.certainty === 'number' && typeof this.contradiction === 'number';
  }

  get pointX(): number {
    return CENTER + this.clamp(this.certainty) * HALF;
  }

  get pointY(): number {
    return CENTER - this.clamp(this.contradiction) * HALF;
  }

  triangle(vertical: 'top' | 'bottom', horizontal: 'left' | 'right'): string {
    const y = vertical === 'top' ? this.top : this.bottom;
    const x = horizontal === 'left' ? this.left : this.right;
    return `${CENTER},${CENTER} ${CENTER},${y} ${x},${CENTER}`;
  }

  color(decisionId: string): string {
    return this.decision(decisionId)?.bgcolor ?? '#6b7280';
  }

  decisionLabel(decisionId: string): string {
    return this.translateService.instant(`service.survey-service.question-final-decision-statuses.${decisionId}.title-no-rev`);
  }

  isActive(status: string): boolean {
    return this.status === status;
  }

  private decision(decisionId: string): any {
    return this.surveyService.questionFinalDecisionStatuses.find((status: any) => status.id === decisionId);
  }

  private clamp(value: number | null): number {
    return Math.max(-1, Math.min(1, Number(value) || 0));
  }
}
